import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MapService } from '../../../services/map/map.service';
import * as ol from 'openlayers';
import { TranslateService } from '@ngx-translate/core';
declare var $;//jquery

export const printConstants = {
    A4: {
        V: {
            width: 20.99, height: 28.70
        },
        H: {
            width: 28.70, height: 16.99
        }
    },
    A3: {
        V: {
            width: 29, height: 40.70
        },
        H: {
            width: 38, height: 24.3
        }
    },
    feature_info_template: "FITXA_A4V"
};

@Component({
    selector: 'app-print-control',
    templateUrl: './print-control.component.html',
    styleUrls: ['./print-control.component.css']
})
export class PrintControlComponent implements OnInit, OnChanges {

    /* Events Emitter's */
    @Output() private addInteraction = new EventEmitter<any>();
    @Output() private addLayerTool = new EventEmitter<any>();
    @Output() private removeInteraction = new EventEmitter<any>();
    @Output() private createPreviewMap = new EventEmitter<any>();
    @Output() private printMap = new EventEmitter<any>();
    @Input() activateInteraction: boolean;
    @Input() hasFinished: boolean;
    private scales: any[];
    private printStateLoading = false;
    private printStateFinished = false;
    private titol_traduit = '';
    public submittedForm;
    public showPreview = false;
    public scale = "25000";
    public orientacio = "H";
    public size = "A4";
    public model = {
        scale: "25000",
        orientacio: "H",
        size: "A4",
        preview: "false"
    };

    public form;
    public events: any[] = []; // use later to display form changes
    constructor(private formBuilder: FormBuilder, private translateService: TranslateService, private mapService: MapService) {

    }

    ngOnInit() {
        console.debug(">>> MeasureDistanceControlComponent ---> ngOnInit");
        this.scales = ['Actual'].concat(this.mapService.getConfigurationSaved()["mapconfig"].scales);
        this.translateService.get('Geoportal Urbanístic').subscribe((traduccio_realitzada_titol: string) => {
            this.titol_traduit = traduccio_realitzada_titol
        });
        this.form = this.formBuilder.group({
            orientacio: new FormControl('H'),
            size: new FormControl('A4'),
            scale: new FormControl(this.scales[0]),
            text_titol: new FormControl(this.titol_traduit)
        });
        $("#printStateLoading").hide();
        $("#printStateFinished").hide();
        // subscribe to form changes
        this.subcribeToFormChanges();
    }

    ngAfterViewInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        console.debug(">>> MeasureDistanceControlComponent --> ngOnChanges");
        try {
            /**/
        }
        catch (e) { console.log("ups, error al print-control.component --> ngOnChanges") };
    }

    subcribeToFormChanges() {
        // initialize stream
        const myFormValueChanges$ = this.form.valueChanges;

        // subscribe to the stream
        myFormValueChanges$.subscribe(x => {
            this.initPrintConfig(x);
        });
    }
    private togglePrintConfig() {
        this.showPreview = !this.showPreview;
        this.initPrintConfig(this.form.value)
    }
    private initPrintConfig(values) {
        console.log(values);

        this.printStateLoading = false;
        this.printStateFinished = false;

        if (values.orientacio === "H") {
            $(".olPrintPreviewMap").css("max-width", "450px");
            let width = parseInt($("#print-options").css("width").replace("px", "")) - 20;
            $(".olPrintPreviewMap").css("width", width + "px");
            $(".olPrintPreviewMap").css("height", "300px");
        } else {
            $(".olPrintPreviewMap").css("max-height", "450px");
            let height = parseInt($("#print-options").css("width").replace("px", "")) - 20;
            $(".olPrintPreviewMap").css("height", height);
            $(".olPrintPreviewMap").css("width", "300px");
        }

        values.width = printConstants[values.size][values.orientacio].width;
        values.height = printConstants[values.size][values.orientacio].height;
        values.showPreview = this.showPreview;
        this.createPreviewMap.emit({
            state: "true",
            config: values
        });
    }

    private submitPrintMap(values) {
        console.log(values);
        /*  this.printStateLoading = true;
          this.printStateFinished = false;*/
        $("#printStateLoading").show();
        $("#printStateFinished").hide();
        if (values.orientacio === "H") {
            $(".olPrintPreviewMap").css("max-width", "450px");
            let width = parseInt($("#print-options").css("width").replace("px", "")) - 20;
            $(".olPrintPreviewMap").css("width", width + "px");
            $(".olPrintPreviewMap").css("height", "300px");
        } else {
            $(".olPrintPreviewMap").css("max-height", "450px");
            let height = parseInt($("#print-options").css("width").replace("px", "")) - 20;
            $(".olPrintPreviewMap").css("height", height);
            $(".olPrintPreviewMap").css("width", "300px");
        }

        values.width = printConstants[values.size][values.orientacio].width;
        values.height = printConstants[values.size][values.orientacio].height;
        values.text_titol = values.text_titol;
        this.printMap.emit({
            state: "true",
            config: values
        });
    }

    private removeInteractionHandler(): void {

        this.createPreviewMap.emit({
            state: "true",
            config: { showPreview: false } //tanquem el print preview
        });

        this.removeInteraction.emit({ closePanel: true, interaction: "olPrintPreview" });
    }

    private addInteractionHandler(): void {
        //this.addInteraction.emit(this.drawInteraction);
    }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools/print-control/print-control.component.ts